const db = {
	stadium: [],
	united: [],
	others: [],
	tools: [],
	unlimiter20: {
		button1: { text: 'Download', link: 'https://unlimiter.net/download' },
		button2: { text: 'Blender Plugin 4.0', link: 'https://github.com/tomek0055/tmunlimiter_blender_plugin' },
		button3: { text: 'Documentation', link: 'https://github.com/tomek0055/TMUnlimiter/wiki' },
		scripts: [],
	},
	unlimiter13: {
		button1: {
			text: 'Download',
			link: process.env.BASE_URL + 'downloads/TMInfinity-1.3.0.2.zip',
			download: 'TMInfinity 1.3.0.2.zip',
		},
		button2: { text: 'Blender Plugin 3.1+', link: 'https://github.com/SuperCoby/TM_Unlimiter_Tool' },
		button3: {
			text: 'Documentation',
			link: process.env.BASE_URL + 'downloads/TMInfinity-Unlimiter-1.3-Documentation.pdf',
			download: 'TMInfinity (Unlimiter 1.3) Documentation.pdf',
		},
		scripts: [],
	},
	unlimiter12: {
		button1: {
			text: 'Download',
			link: process.env.BASE_URL + 'downloads/Unlimiter-1.2.0.0.rar',
			download: 'Unlimiter 1.2.0.0.rar',
		},
		button2: {
			text: 'Documentation',
			link: process.env.BASE_URL + 'downloads/TMUnlimiter-manual-ENG.pdf',
			download: 'TMUnlimiter manual - ENG.pdf',
		},
		scripts: [],
	},
};

export default db;
